var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicketSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "me-2",
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 199",
    transform: "translate(-8010 17388)",
    style: {
      clipPath: "url(#810bjwccqa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61892"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25788",
    d: "M599.277 440.542a1.214 1.214 0 0 1 1.229 1.385v1.871a1.135 1.135 0 0 1-.684 1.125.62.62 0 0 0 0 1.174 1.136 1.136 0 0 1 .686 1.124v2a1.159 1.159 0 0 1-1.239 1.23h-14.635a1.159 1.159 0 0 1-1.235-1.234v-2.005a1.132 1.132 0 0 1 .69-1.12.623.623 0 0 0 .415-.59.631.631 0 0 0-.425-.584 1.12 1.12 0 0 1-.679-1.094v-2.038a1.128 1.128 0 0 1 1.212-1.211 1.356 1.356 0 0 0 1.125-.477c2.064-2.093 4.151-4.166 6.23-6.244a1.211 1.211 0 0 1 1.985 0c.425.425.847.854 1.276 1.275a1.17 1.17 0 0 1 .32 1.339.525.525 0 0 0 .137.665.866.866 0 0 0 .639.13 1.275 1.275 0 0 1 1.42.38c.393.411.8.8 1.2 1.207a1.259 1.259 0 0 1 .333 1.692zm-3.335 8.908v-7.879h-11.145c-.268 0-.414.041-.4.36.021.6 0 1.2.015 1.8a.456.456 0 0 0 .2.321 1.634 1.634 0 0 1 0 2.919.455.455 0 0 0-.2.323c-.02.578.01 1.158-.017 1.736-.016.347.108.429.438.428 3.585-.011 7.169-.007 10.753-.007zm-5-13.142c1.4 1.4 2.762 2.768 4.138 4.13a.556.556 0 0 0 .353.12c.578.012 1.162-.038 1.734.019a1.254 1.254 0 0 0 1.169-.526c.13-.155.129-.257-.01-.393-.453-.444-.894-.9-1.352-1.339a.378.378 0 0 0-.317-.082 1.628 1.628 0 0 1-2.082-2.079.34.34 0 0 0-.053-.29q-.693-.722-1.417-1.415a.305.305 0 0 0-.3 0c-.62.604-1.229 1.221-1.862 1.855zM597 449.449h2.263c.227 0 .24-.142.239-.312 0-.612.009-1.225-.01-1.836a.451.451 0 0 0-.192-.327 1.609 1.609 0 0 1-.907-1.455 1.589 1.589 0 0 1 .922-1.476.353.353 0 0 0 .176-.238c.015-.668.016-1.336 0-2a.312.312 0 0 0-.209-.221c-.754-.017-1.508-.01-2.282-.01zm-3.316-8.9-3.423-3.425-3.427 3.425z",
    transform: "translate(7427.05 -17820.898)",
    style: {
      fill: "#ff295c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25789",
    d: "M591.734 456.862v-.962h7.507v.962z",
    transform: "translate(7422.254 -17833.872)",
    style: {
      fill: "#ff295c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25790",
    d: "M599.269 460.63v.963h-7.506v-.963z",
    transform: "translate(7422.237 -17836.593)",
    style: {
      fill: "#ff295c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25791",
    d: "M591.737 466.329v-.963h7.5v.963z",
    transform: "translate(7422.252 -17839.315)",
    style: {
      fill: "#ff295c"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSvg);
export default __webpack_public_path__ + "static/media/ticket-svg.3074110ff1ef77dc5a25490e8705c60b.svg";
export { ForwardRef as ReactComponent };